import React, { useMemo } from "react";

import { useCurrentUser } from "@qualio/ui-components";
import { CKEditor } from "@ckeditor/ckeditor5-react";

import { getDocumentEditorConfig } from "./config";
import { EditorContainer } from "./Editor.styles";
import { EditorTypes } from "./EditorTypes";
import { extractInnerCKEditorHTMLData } from "./extractInnerCKEditorHTMLData";

export const Editor: React.FC<EditorTypes> = ({ onChange, value }) => {
  const editValue = extractInnerCKEditorHTMLData(value);

  const { companyId } = useCurrentUser();
  const config = useMemo(() => getDocumentEditorConfig(companyId), [companyId]);

  return (
    <EditorContainer>
      <CKEditor
        editor={CKEDITOR.ClassicEditor}
        config={config}
        data={editValue}
        onChange={(_: any, editor: any) => {
          const data = editor.getData();
          onChange(`<div class="ck-content">${data}</div>`);
        }}
      />
    </EditorContainer>
  );
};
